
export default {
    name: 'Logo',

    props: {
        color: {
            type: String,
            default: '#D7907F',
        },
    },
}
